import { domain, i18n, DateFormatter } from 'arm-common';
import * as layouts from 'arm-core-layouts';
import * as agui from 'arm-gui/dist/controls';
import * as React from 'react';
import { connect } from 'react-redux';
import Rest from '../../webapi/Rest';
import DocumentiActions from '../documenti/DocumentiActions';



class DataSourcePreviewTab extends React.Component {
    constructor(props) {
        super(props);
        this.componentName = "[Upload.jsx] ";
        this.state = {

        };
    }


    componentDidMount() {
        console.log(this.componentName + ' componentDidMount');

    }


    render() {
        const { dataSource, handleChangeDSPrevPar, dsPreviewParams } = this.props;
        const baseUrl = Rest.restBaseurl;

        return (

            <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'space-between', margin: '2rem 0rem' }}>

                <div style={{ width: '100%', border: '1px solid #e4e4e4', boxShadow: '0 1px 5px 0 rgb(0 0 0 / 10%), 0 2px 2px 0 rgb(0 0 0 / 2%)', padding: '1rem' }}>

                    <span>{i18n("ARM_CORE_PRINT.SHARED.PARAMETRI", 'Valorizza i parametri per effettuare la stampa')}</span>
                    <div className='row' style={{ margin: '1.5rem' }}>

                        {dataSource.listParam && dataSource.listParam.length > 0 ?


                            dataSource.listParam.map((param, index) =>

                                <div className='col-6'>
                                    <agui.CoolTextInput
                                        id="value"
                                        value={dsPreviewParams ? dsPreviewParams.get(param.nome) : null}
                                        onChange={(value) => handleChangeDSPrevPar(param.nome, value)}
                                        label={param.nome}
                                    />
                                </div>
                            )
                            :
                            <span>{i18n("ARM_CORE_PRINT.SHARED.PARAMETRI", 'Nessun parametro presento per questa data source')}</span>
                        }
                    </div>
                </div>
            </div>
        );
    }
}


function mapDispatchToProps(dispatch) {
    return {
        handleChangeDSPrevPar(id, value) {
            return dispatch(DocumentiActions.handleChangeDSPrevPar(id, value));
        }
    }

};

function mapStateToProps(state) {
    return {
        dataSource: state.documentiReducer.dataSource,
        dsPreviewParams: state.documentiReducer.dsPreviewParams,
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(DataSourcePreviewTab);
